import { useContext } from "react";
import LicenseContext from "../LicenseContext";

/**
 * @description Returns the license context
 */
export const useLicenseContext = () => {
  return useContext(LicenseContext);
};
